import { useCallback } from 'react'
import { UseData } from './useData'

type Props = Pick<UseData, 'setReOrderDrawerOpen'>

export function useHandlers(props: Props) {
  const { setReOrderDrawerOpen } = props

  const handleCloseReOrderDrawer = useCallback(() => {
    setReOrderDrawerOpen(false)
  }, [setReOrderDrawerOpen])

  const handleReOrderServicesButtonClick = useCallback(() => {
    setReOrderDrawerOpen(true)
  }, [setReOrderDrawerOpen])

  return {
    handleCloseReOrderDrawer,
    handleReOrderServicesButtonClick,
  } as const
}
